import {Button, type ButtonProps} from 'react-aria-components'

import isFunction from '@/utils/types/guards/isFunction'

import style from './PrimaryButton.module.scss'

type ButtonSize = 'xl' | 'lg' | 'md' | 'sm'

interface Props extends ButtonProps {
  size?: ButtonSize
  isPending?: boolean
  showPendingIndicator?: boolean
  pendingIndicatorClassName?: string
  ref?: Ref<HTMLButtonElement>
}

const PrimaryButton = deepMemo<Props>(function PrimaryButton({
  showPendingIndicator = true,
  pendingIndicatorClassName,
  ...props
}): JSX.Element {
  const defaultClassName: string = clsx(
    style.Button,
    style.Rounded,
    (() => {
      switch (props.size) {
        case 'xl':
          return style.ExtraLarge
        case 'lg':
          return style.Large
        case 'md':
          return style.Medium
        case 'sm':
          return style.Small
        case undefined:
          return style.Large
      }
    })(),
  )

  return (
    <Button
      {...props}
      className={data =>
        clsx(
          defaultClassName,
          isFunction(props.className) ? props.className(data) : props.className,
        )
      }
    >
      {showPendingIndicator && props.isPending && (
        <div
          className={clsx(
            style.Loader,
            props.size === 'sm' && style.Small,
            pendingIndicatorClassName,
          )}
        />
      )}
      {props.children as ReactNode}
    </Button>
  )
})()

export default PrimaryButton
